import request from "../helpers/request";

// por reemplazar a función al subir a dev.api
export function GetContactBrokerList() {
  let dataRequest = {};
  dataRequest.type = "internal";
  return new Promise((resolve, reject) => {
    request("/Contacts/List", dataRequest)
      .then(response => {
        resolve({
          ContactBroker: response.data.ContactsList
        });
      })
      .catch(err => {
        reject(err);
      });
  });
}
